"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetContentMode = void 0;
/**
 * Represents a mode number to indicate what kind of content to retrieve when call Editor.getContent()
 */
var GetContentMode;
(function (GetContentMode) {
    /**
     * The clean content without any temporary content only for editor.
     * This is the default value. Call to Editor.getContent() with trigger an ExtractContentWithDom event
     * so that plugins can remove their temporary content, and will return the HTML content
     * which is ready for save to storage.
     */
    GetContentMode[GetContentMode["CleanHTML"] = 0] = "CleanHTML";
    /**
     * Retrieve the raw HTML string in current editor. Temporary content will be included.
     */
    GetContentMode[GetContentMode["RawHTMLOnly"] = 1] = "RawHTMLOnly";
    /**
     * Retrieve the raw HTML string in current editor with a selection marker. This can be used for
     * save current editor state and call to SetContent with this result can fully restore editor state
     * including current selection
     */
    GetContentMode[GetContentMode["RawHTMLWithSelection"] = 2] = "RawHTMLWithSelection";
    /**
     * Get plain text content only, all format will be ignored
     */
    GetContentMode[GetContentMode["PlainText"] = 3] = "PlainText";
    /**
     * A fast way to get plain text content, the line-end positions may not be exactly same with HTML content,
     * but the text content should be the same. This is used for quickly retrieve text content and check
     * text only
     */
    GetContentMode[GetContentMode["PlainTextFast"] = 4] = "PlainTextFast";
})(GetContentMode = exports.GetContentMode || (exports.GetContentMode = {}));
//# sourceMappingURL=GetContentMode.js.map